import { setCustomerForCartFn } from "@/api/vendure/order/order.query.options";
import type {
  AttachCustomerPayload,
  OrderDto,
} from "@/api/vendure/order/order.types";
import { mintGuestTokenFn } from "./auth.query.options";
import { setToken } from "./token";

export async function mintGuestAndAttachCustomer(
  channelToken: string,
  payload: AttachCustomerPayload,
): Promise<{ cart: OrderDto }> {
  const { token } = await mintGuestTokenFn();
  setToken(token);
  return setCustomerForCartFn(channelToken, payload);
}
